// extracted by mini-css-extract-plugin
export var dropdownButton = "_2w-0";
export var fullWidthDropdownButton = "_2w-1";
export var icon = "_2w-3";
export var iconPlaceholder = "_2w-2";
export var shortcutContainer = "_2w-4";